import React, { useState } from 'react';
import { aiApi } from '../../services/api';
import { SparklesIcon } from '@heroicons/react/24/outline';

const ProposalWriter: React.FC = () => {
  const [section, setSection] = useState('Technical Approach');
  const [requirements, setRequirements] = useState('');
  const [generated, setGenerated] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerate = async () => {
    setIsLoading(true);
    try {
      const response = await aiApi.generateProposal({
        section,
        requirements,
        companyInfo: {},
      });
      setGenerated(response.data.generated.content);
    } catch (error) {
      console.error('Generation failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">AI Proposal Writer</h1>
        <p className="mt-1 text-gray-600">Generate compliant proposal sections in minutes</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          <div>
            <label className="label">Section Type</label>
            <select
              value={section}
              onChange={(e) => setSection(e.target.value)}
              className="input"
            >
              <option>Technical Approach</option>
              <option>Past Performance</option>
              <option>Management Plan</option>
              <option>Quality Assurance</option>
            </select>
          </div>

          <div>
            <label className="label">Requirements</label>
            <textarea
              value={requirements}
              onChange={(e) => setRequirements(e.target.value)}
              rows={10}
              className="input"
              placeholder="Paste the requirements from the RFP here..."
            />
          </div>

          <button
            onClick={handleGenerate}
            disabled={isLoading || !requirements.trim()}
            className="btn-primary flex items-center gap-2 disabled:opacity-50"
          >
            <SparklesIcon className="h-5 w-5" />
            {isLoading ? 'Generating...' : 'Generate Section'}
          </button>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Generated Content</h3>
          {generated ? (
            <div className="prose prose-sm max-w-none">
              <pre className="whitespace-pre-wrap text-sm text-gray-700 bg-gray-50 p-4 rounded-lg">
                {generated}
              </pre>
            </div>
          ) : (
            <div className="text-center py-12 text-gray-400">
              <SparklesIcon className="mx-auto h-12 w-12" />
              <p className="mt-2">Generated content will appear here</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProposalWriter;
